export class ObjectUtil {
  static ignoreNullValue(target: any): any {
    let result: any = {};
    for (let i in target) {
      if (target[i] != null || (typeof target[i] == 'string' && target[i] == '')) result[i] = target[i];
    }
    return result;
  }

  /*
  * assign
  */
  static mergeValue(target: any, source: any): any {
    let result: any = {};
    for (let i in target) {
      if (source[i] != null || (typeof target[i] == 'string' && target[i] == '')) {
        result[i] = source[i];
      } else {
        result[i] = target[i];
      }
    }
    return result;
  }

  static combineValue(target: any, source: any): any {
    return Object.assign(target, source);
  }

  static clone(source: any) {
    return Object.assign({}, source);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/object.ts